import {
  CommandType,
  ReceiptPrintLendStatusCollectionData,
  ReceiptPrintLendStatusData,
  ReceiptPrintLendStatusDataToJSON,
  ReceiptPrintName
} from '@/types'
import {
  authUserStore,
  dataStore,
  systemCodeStore
} from '@/utils/store-accessor'
import { lendApi, LendCollection, SystemCode } from '@/api'
import { plainToDateFormat } from '@/utils/date'
import { isGroupUser } from '@/utils/user'
import { GlobalWebSocketService } from '@/plugins/websocket'

export function printLendStatusReceipt(
  collections: LendCollection[],
  checkedIds: number[],
  userId: string,
  userType: SystemCode
) {
  if (collections.length === 0) {
    return
  }

  if (isGroupUser(userType) && dataStore.groupLendOutputPrinter) {
    lendApi.groupListPrint({
      userId
    })

    return
  }

  const receiptPrintLendStatusData: ReceiptPrintLendStatusData = {
    title: dataStore.receiptInfoLendStatusTitle,
    branchNamePrefix: dataStore.receiptInfoLendStatusBranchNamePrefix,
    displayAuthor: dataStore.receiptInfoLendStatusDisplayAuthor,
    displayReserveCount: dataStore.receiptInfoLendStatusDisplayReserveCount,
    dueDateLabel: dataStore.receiptInfoLendStatusDueDateLabel,
    userNoMaskDigit: dataStore.receiptInfoLendStatusUserNoMaskDigit,
    totalLabel: dataStore.receiptInfoLendStatusTotalLabel,
    totalUnitLabel: dataStore.receiptInfoLendStatusTotalUnitLabel,
    totalLabelFormatType: dataStore.receiptInfoLendStatusTotalLabelFormatType,
    notices: dataStore.receiptInfoLendStatusNotices,
    collectionPartitionCount:
      dataStore.receiptInfoLendStatusCollectionPartitionCount,
    branchName: authUserStore.authUser.branchCode.name,
    userId,
    collections: convertLendStatusCollectionsFormat(collections, checkedIds),
    lendClassifications: systemCodeStore.getClassification
  }
  GlobalWebSocketService.sendReceiptPrintMessage({
    command: CommandType.ReceiptPrintLendStatus,
    name: ReceiptPrintName.ReceiptPrintLendStatus,
    data: ReceiptPrintLendStatusDataToJSON(receiptPrintLendStatusData),
    subject: `利用者番号：${userId}`
  })
}

export function convertLendStatusCollectionsFormat(
  array: LendCollection[],
  checkedIds: number[]
): ReceiptPrintLendStatusCollectionData[] {
  return array
    .filter(item => {
      const isChecked = checkedIds.length === 0 || checkedIds.includes(item.id)
      const isLost = item.message === '紛失' || item.message === '紛失手'

      return isChecked && (dataStore.displayLendStatusLostCollection || !isLost)
    })
    .map(collection => ({
      collectionNo: collection.collectionNo,
      displayTitle: collection.displayTitle,
      displayAuthor: collection.displayAuthor,
      dueDate: plainToDateFormat(collection.dueDate),
      reserveCount: collection.reserveCount.toString(),
      lendClassification: collection.lendClassification
    }))
}
